import React from 'react';
import { motion, useTransform } from 'framer-motion';
import type { CinemaLink } from '../types/chat';
interface CinemaOverlayProps {
  link: CinemaLink;
}

/**
 * Movie mode for Pixel's full-charge short: the page dims (lights out) and letterbox bars slide in.
 * Values are driven per frame by the 3D scene.
 */
export function CinemaOverlay({
  link
}: CinemaOverlayProps) {
  const dimOpacity = useTransform(link.dark, v => v * 0.82);
  const topY = useTransform(link.bars, v => `${(v - 1) * 100}%`);
  const bottomY = useTransform(link.bars, v => `${(1 - v) * 100}%`);
  return <div className="pointer-events-none" aria-hidden="true" data-id="element-9" data-mp="2ejspcpi1x1ny">
      {/* Lights out — under Pixel, over the page */}
      <motion.div style={{
      opacity: dimOpacity
    }} className="fixed inset-0 z-[35] bg-black" data-id="element-10" data-mp="2im74ozmihjah" />

      {/* Letterbox — over everything */}
      <motion.div style={{
      y: topY
    }} className="fixed inset-x-0 top-0 z-[60] h-[11vh] bg-black" data-id="element-11" data-mp="k844y7t1w6w6" />
      <motion.div style={{
      y: bottomY
    }} className="fixed inset-x-0 bottom-0 z-[60] h-[11vh] bg-black" data-id="element-12" data-mp="o869coq67ef5" />
    </div>;
}